import { render, staticRenderFns } from "./AdminUmbTypeForm.vue?vue&type=template&id=435754a0"
import script from "./AdminUmbTypeForm.vue?vue&type=script&lang=ts"
export * from "./AdminUmbTypeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports